/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import "../../../assets/styles/custom-style.css";

import { useAuth } from "../../../auth";
import "../../../assets/styles/custom-style.scss";
import {
  listBankData,
  listChefSettlement,
  listChefWelletDetail,
  listWalletAmount,
} from "../core/_requests";
import { Link, useNavigate } from "react-router-dom";
import { useFormattedUtils } from "../../../component/dateUtils";
interface Bank {
  primaryId: any;
  chefId: string | undefined;
  bankId: string | undefined;
  routingNumber: string;
  accountName: string;
  accountNumber: string;
  phoneNumber: string;
  address: string;
  createdBy: any;
  updatedBy: any;
}

const ListSettlements = () => {
  const { formatDateUS } = useFormattedUtils();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [listSettlements, setListSettlements] = useState<Bank[]>([]);
  const [bank, setListBank] = useState<any>();
  const [walletAmount, setWalletAmount] = useState<any>();
  const [walletList, setWallet] = useState<any[]>([]);
  const [settlement, setSettlement] = useState<any[]>([]);
  const chefId = currentUser?.uuid;
  const formatCurrency = (amount: number = 0) =>
  `${amount < 0 ? "-" : ""}$${Math.abs(amount).toFixed(2)}`;

  useEffect(() => {
    listChefWelletDetail(chefId).then((res) => {
      setWallet(res?.data);
    })
      .catch((error) => {
        console.error("Error fetching chef wallet:", error);
      });
  }, []);
  useEffect(() => {
    listChefSettlement(chefId)
      .then((res) => {
        setSettlement(res?.data);
      })
      .catch((error) => {
        console.error("Error fetching chef settlement:", error);
      });

  }, []);
  useEffect(() => {
    listBankData(chefId).then((res) => {
      setListSettlements(res?.data);
      
      setListBank(res);
    });
  }, []);
  useEffect(() => {
    listWalletAmount(chefId).then((res) => {
      
      setWalletAmount(res?.data);
          });
  }, []);

  const EditSettlements = (primaryId: string) => {
    navigate("/settlements/edit/" + primaryId);
  };

  const deleteSettlements = (primaryId: string) => {
    navigate("/settlements/delete/" + primaryId);
  }; 

  const clickAllSettlements = () => {
    navigate("/settlements/all-settlement");
  };
  const clickAllWallets = () => {
    navigate("/settlements/all-wallet");
  };
  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            {/*  */}
            <section className="row main-content settlement-content">
              <div className="title mb-3 d-flex align-items-center justify-content-between">
                <h3 className="mb-0">Settlement</h3>
                <button
                  className="btn btn-primary btn-ico rounded-5 btn-empty small"
                  onClick={clickAllSettlements}
                >
                  <i className="material-symbols-outlined">history</i>
                  <span>Transaction History</span>
                </button>
              </div>

              <div className="col-12">
                <div className="row">
                  <div className="col-md-8">
                    <div className="wallet-snippet">
                      <div className="amount-text">
                        <p>
                          <small className="text-white">
                            Total amount in your wallet
                          </small>
                        </p>

  <span className="amount-text">
  {formatCurrency(walletAmount?.balance)}
</span>

                        <p className="mt-4 mb-0 opacity-75 d-flex align-items-center">
                          <span className="tiny text-white">
                            Your total amount and withdrawal amount are not same
                          </span>
                          <i
                            className="ms-1 material-symbols-outlined info-ico"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Withdrwable balance (=) Total Amount (-) Deposit Amount"
                          >
                            info
                          </i>
                        </p>
                      </div>
                      <span></span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row h-100">
                      <div className="col-12 mb-4">
                        <div className="snippet-block h-100 d-flex align-items-center justify-content-between">
                          <div className="cont d-flex align-items-center">
                            <img
                              className="img-fluid me-3"
                              src="/assets/images/settlement-mode-ico.svg"
                              alt="ico"
                            />
                            <div>
                              <p className="mid-gray mb-0">
                                <small>Settlement Mode</small>
                              </p>
                              <h6 className="mb-0 fw-med">Auto</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      {bank?.data?.length === 0 ? (
                        <div className="col-12">
                          <div className="snippet-block h-100 empty">
                            <Link to="/settlements/add" className="add-bank">
                              <i className="material-symbols-outlined me-1">
                                account_balance
                              </i>
                              Add your bank account here
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <div className="col-12">
                          {bank?.data?.map((bankItem: any, index: any) => (
                            <div key={index} className="snippet-block h-100">
                              <div className="cont d-flex align-items-center justify-content-between">
                                <div>
                                  <p className="mb-2 mid-gray">
                                    <small>
                                      A/C Name : {bankItem?.accountName}
                                    </small>
                                  </p>
                                  <h6 className="fw-med mb-2">
                                    Nick Name : {bankItem.nickName}
                                  </h6>
                                  <p className="mb-0 mid-gray">
                                    <small>
                                      Bank Name :{" "}
                                      <small>{bankItem.bankId}</small>
                                    </small>
                                  </p>
                                </div>
                               
                                {/* <a
                                  className="btn btn-primary btn-ico btn-empty change-btn"
                                  onClick={() =>
                                    EditSettlements(bankItem.primaryId)
                                  }
                                >
                                  <span className="material-symbols-outlined">
                                    edit
                                  </span>
                                </a> */}
                                <a
                                  className="btn btn-primary btn-ico btn-empty change-btn"
                                  onClick={() =>
                                    deleteSettlements(bankItem.primaryId)
                                  }
                                >
                                  <span className="material-symbols-outlined">
                                    delete
                                  </span>
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 mt-4 mb-4">
                    <div className="snippet-block">
                      <div className="head">
                        <h6 className="mb-0">Recent Wallet</h6>
                        <a
                          href="#"
                          className="text-link"
                          onClick={clickAllWallets}
                        >
                          View All
                          <i className="material-symbols-outlined fall">
                            arrow_forward
                          </i>
                        </a>
                      </div>
                      {/* Check if wallet array is empty */}

                      {walletList.length === 0 ? (
                        <div className="snippet-content">
                          <div className="no-data">
                            <img
                              className="img-fluid mb-3"
                              src="/assets/images/no-data-img.svg"
                              alt="No Data"
                            />
                            <p className="mb-0 mid-gray">
                              <small>
                               Your Wallet's Feeling Light – Add Funds to Get Started!
                              </small>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="snippet-content">
                          <table className="table custom-table mb-0">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Type</th>
                                <th>Date</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Use slice to get only the first 5 elements of the settlementDetail array */}
                              {walletList
                                .slice(0, 5)
                                .map((walletDetail: any, index: any) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                   <td>
  <Link
    to={`/settlements/wallet-details/${walletDetail.primaryId}`}
    className="text-decoration-none"
  >
    {(() => {
      switch (walletDetail.walletType) {
        case 1:
          return `Order (${walletDetail?.orderId})`;
        case 2:
          return "Bonus";
        case 3:
          return "Plan Refund";
        case 4:
          return "Debit Subscription";
        case 5:
          return "Subscription Bonus";
        default:
          // If walletType is a string (like from your API)
          return walletDetail.walletType || "Unknown";
      }
    })()}
  </Link>
</td>


                                    <td>{formatDateUS(walletDetail?.date)}</td>
                                    <td>
                                      {walletDetail?.debit
                                        ? walletDetail.debit.toFixed(2)
                                        : "0.00"}
                                    </td>
                                    <td>
                                      {walletDetail?.credit
                                        ? walletDetail.credit.toFixed(2)
                                        : "0.00"}
                                    </td>
                                    <td>
                                      {walletDetail?.balance
                                        ? walletDetail.balance.toFixed(2)
                                        : "0.00"}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 mt-4 mb-4">
                    <div className="snippet-block">
                      <div className="head">
                        <h6 className="mb-0">Recent Settlements</h6>
                        <a
                          href="#"
                          className="text-link"
                          onClick={clickAllSettlements}
                        >
                          View All
                          <i className="material-symbols-outlined fall">
                            arrow_forward
                          </i>
                        </a>
                      </div>
                      {/* Check if wallet array is empty */}

                      {settlement.length === 0 ? (
                        <div className="snippet-content">
                          <div className="no-data">
                            <img
                              className="img-fluid mb-3"
                              src="/assets/images/no-data-img.svg"
                              alt="No Data"
                            />
                            <p className="mb-0 mid-gray">
                              <small>
                                 No Funds Settled Yet – Check Back Soon!
                              </small>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="snippet-content">
                          <table className="table custom-table mb-0">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Settlement Id</th>
                                <th>Date</th>
                                <th> ($)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* Use slice to get only the first 5 elements of the settlementDetail array */}
                              {settlement
                                .slice(0, 5)
                                .map((settlementDetail: any, index: any) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {" "}
                                      <Link
                                        to={`/settlements/settlement-details/${settlementDetail.primaryId}`}
                                        className="text-decoration-none"
                                      >
                                        {" "}
                                        {settlementDetail.settlementId}{" "}
                                      </Link>
                                    </td>
                                    <td>{formatDateUS(settlementDetail.date)}</td>
                                    <td>
                                      ${settlementDetail.amount.toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ListSettlements;
